/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  LogCustomEventUrlResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    LogCustomEventUrlResponseFromJSON,
    LogCustomEventUrlResponseToJSON,
} from '../models/index';

export interface GetEventsCustomUrlRequest {
    url?: string;
}

/**
 * CustomEventsApi - interface
 * 
 * @export
 * @interface CustomEventsApiInterface
 */
export interface CustomEventsApiInterface {
    /**
     * Log user as clicked to URL.
     * @param {string} [url] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomEventsApiInterface
     */
    getEventsCustomUrlRaw(requestParameters: GetEventsCustomUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogCustomEventUrlResponse>>;

    /**
     * Log user as clicked to URL.
     */
    getEventsCustomUrl(requestParameters: GetEventsCustomUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogCustomEventUrlResponse>;

}

/**
 * 
 */
export class CustomEventsApi extends runtime.BaseAPI implements CustomEventsApiInterface {

    /**
     * Log user as clicked to URL.
     */
    async getEventsCustomUrlRaw(requestParameters: GetEventsCustomUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogCustomEventUrlResponse>> {
        const queryParameters: any = {};

        if (requestParameters['url'] != null) {
            queryParameters['url'] = requestParameters['url'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/events-custom/url`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogCustomEventUrlResponseFromJSON(jsonValue));
    }

    /**
     * Log user as clicked to URL.
     */
    async getEventsCustomUrl(requestParameters: GetEventsCustomUrlRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogCustomEventUrlResponse> {
        const response = await this.getEventsCustomUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
